import React from 'react'
import { Button, Popup, Loading } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { more } from 'src/assets/png'
import { useStyles } from './styles'
import UpdateLot from './UpdateLot'
import { useLots } from './hooks/useLots'
import { LotCard } from './components/LotCard'
import { Grid } from '@material-ui/core'
import { AssignmentOutlined } from '@material-ui/icons'

export const Lots: React.FC = () => {
  const style = useStyles()
  const { lots, isLoading, isLotModalOpen, selectedLot, handleOpenModal, handleCloseModal } = useLots()

  return (
    <>
      <div className={style.lotsHeaderContent}>
        <PageTitle title='Lotes' />
        <div className={style.buttonContainer}>
          <Button className={style.buttonWrapper} onClick={() => handleOpenModal()}>
            <img src={more} alt='Incluir' />
            CADASTRAR
          </Button>
        </div>
      </div>
      {isLoading ? (
        <Loading />
      ) : (
        <div className={style.lotsContainer}>
          {lots.length > 0 ? (
            <Grid container spacing={3}>
              {lots.map((lot) => (
                <Grid key={lot.idLote || lot.id} item xs={12} sm={6} md={4} lg={3}>
                  <LotCard lot={lot} onClick={() => handleOpenModal(lot)} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <div className={style.emptyState}>
              <div className={style.emptyStateIcon}>
                <AssignmentOutlined style={{ fontSize: 48 }} />
              </div>

              <div className={style.emptyStateContent}>
                <h3 className={style.emptyStateTitle}>Nenhum lote encontrado</h3>
                <p className={style.emptyStateDescription}>
                  Você ainda não possui lotes cadastrados. Organize seus animais criando seu primeiro lote.
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {isLotModalOpen && (
        <Popup
          title={selectedLot ? 'Editar Lote' : 'Cadastrar Lote'}
          onClose={handleCloseModal}
          closeOnClickOutside={false}
          headerBadge={() =>
            selectedLot && (
              <div className={style.animalCount}>
                <span className={style.countLabel}>Animais:</span>
                <span className={style.countValue}>{selectedLot?.animais || '0'}</span>
              </div>
            )
          }
        >
          <UpdateLot data={selectedLot} onClose={handleCloseModal} />
        </Popup>
      )}
    </>
  )
}
